import { writable } from 'svelte/store'

let user = {
  username: '',
  userInfo: null,
  roles: [],
  blocked: false
}

export function is(userRoles, ...roles) {
  return roles.some(role => userRoles.includes(role))
}

export let userStore = writable(user)

export const cleanUserStore = () => {
  localStorage.clear()
  userStore.update(p => ({ ...p, username: null, userInfo: null, roles: [] }))
}

export const showLockInfo = () => {
  userStore.update(p => ({ ...p, blocked: true}))
}

export let cities = writable([])
export let countries = writable([])

let installedBase = {
  machine_no: ''
}

export let selectedInstalledBase = writable(installedBase)

// filters with select items
export let selectedGroups = writable({})

let _projectFilters = {
  platforms: {key: 'platforms', value: '', label: 'Machine model / Product group', select: []},
  models: {key: 'models', value: '', label: 'Platform', select: []},

  WarrantyDate1: {
    key: 'WarrantyDate', value: '', label: 'from', spec: 'min', date: true,
    roles: ['ib_sales_unit', 'ib_supervisor'],
    group: 'Warranty end date',
  },
  WarrantyDate2: {
    key: 'WarrantyDate', value: '', label: 'to', spec: 'max', date: true,
    roles: ['ib_sales_unit', 'ib_supervisor'],
    group: 'Warranty end date',
  },

  su_erp_proj: {key: 'su_erp_proj', value: '', label: 'Project number'},

  eu_name: {key: 'eu_name', value: '', label: 'End user name'},
  eu_city: {
    key: 'eu_city',
    value: '',
    label: 'End user city',
    city: true,
    country: 'eu_country'
  },
  eu_country: {key: 'eu_country', value: '', label: 'End user country', country: true},

  shcu_name: {key: 'shcu_name', value: '', label: 'Ship to customer name'},
  shcu_city: {
    key: 'shcu_city',
    value: '',
    label: 'Ship to city',
    city: true,
    country: 'shcu_country'
  },
  shcu_country: {key: 'shcu_country', value: '', label: 'Ship to country', country: true},

  sa: {
    key: 'sa', value: '', label: 'Service agreement signed', select: [],
    roles: ['ib_sales_unit', 'ib_supervisor']
  },
  sa_end1: {
    key: 'sa_end', value: '', label: 'from', spec: 'min', date: true,
    roles: ['ib_sales_unit', 'ib_supervisor'],
    group: 'Service agreement end',
  },
  sa_end2: {
    key: 'sa_end', value: '', label: 'to', spec: 'max', date: true,
    roles: ['ib_sales_unit', 'ib_supervisor'],
    group: 'Service agreement end',
  },
  AssetValue: {
    key: 'AssetValue', value: '', label: 'Asset value, min', spec: 'min', type: 'number',
    roles: ['ib_sales_unit', 'ib_supervisor']
  },

  country_key: {key: 'country_key', value: '', label: 'Sales office', select: []},

  serials: {
    key: 'serials', min_value: '', max_value: '', label: 'Serial number', range_list: true,
    roles: ['ib_sales_unit', 'ib_supervisor'],
    group: 'Serial number',
  },

  GKAM: {
    key: 'GKAM', value: '', label: 'Key account', select: [],
    roles: ['ib_sales_unit', 'ib_supervisor']
  },

  op_center: {
    key: 'op_center', value: '', label: 'Operation center', select: [],
    roles: ['ib_sales_unit', 'ib_supervisor']
  },

  is_sat: {
    key: 'is_sat', value: '', label: 'SAT is signed', select: [],
    roles: ['ib_sales_unit', 'ib_supervisor']
  },

  SATDate1: {
    key: 'SATDate', value: '', label: 'from', spec: 'min', date: true,
    roles: ['ib_sales_unit', 'ib_supervisor'],
    group: "SAT date"
  },
  SATDate2: {
    key: 'SATDate', value: '', label: 'to', spec: 'max', date: true,
    roles: ['ib_sales_unit', 'ib_supervisor'],
    group: "SAT date"
  },

  // sales_unit: {key: 'sales_unit', value: '', label: 'Sales unit'},
}

let _machineFilters = {
  ProductGroup: {key: 'ProductGroup', value: '', label: 'Machine model / Product group', select: []},
  model: {key: 'model', value: '', label: 'Platform', select: []},

  WarrantyDate1: {
    key: 'WarrantyDate', value: '', label: 'from', spec: 'min', date: true,
    roles: ['ib_sales_unit', 'ib_supervisor'],
    group: 'Warranty end date',
  },
  WarrantyDate2: {
    key: 'WarrantyDate', value: '', label: 'to', spec: 'max', date: true,
    roles: ['ib_sales_unit', 'ib_supervisor'],
    group: 'Warranty end date',
  },

  su_erp_proj: {key: 'su_erp_proj', value: '', label: 'Project number'},

  eu_name: {key: 'eu_name', value: '', label: 'End user name'},
  eu_city: {
    key: 'eu_city',
    value: '',
    label: 'End user city',
    city: true,
    country: 'eu_country'
  },
  eu_country: {key: 'eu_country', value: '', label: 'End user country', country: true},

  shcu_name: {key: 'shcu_name', value: '', label: 'Ship to customer name'},
  shcu_city: {
    key: 'shcu_city',
    value: '',
    label: 'Ship to city',
    city: true,
    country: 'shcu_country'
  },
  shcu_country: {key: 'shcu_country', value: '', label: 'Ship to country', country: true},

  sa: {
    key: 'sa', value: '', label: 'Service agreement signed', select: [],
    roles: ['ib_sales_unit', 'ib_supervisor']
  },
  sa_end1: {
    key: 'sa_end', value: '', label: 'from', spec: 'min', date: true,
    roles: ['ib_sales_unit', 'ib_supervisor'],
    group: 'Service agreement end',
  },
  sa_end2: {
    key: 'sa_end', value: '', label: 'to', spec: 'max', date: true,
    roles: ['ib_sales_unit', 'ib_supervisor'],
    group: 'Service agreement end',
  },

  country_key: {key: 'country_key', value: '', label: 'Sales office', select: []},

  serial: {
    key: 'sn', min_value: '', max_value: '', label: 'Serial number', range_list: true,
    roles: ['ib_sales_unit', 'ib_supervisor'],
    group: ['Serial number']
  },

  GKAM: {
    key: 'GKAM', value: '', label: 'Key account', select: [],
    roles: ['ib_sales_unit', 'ib_supervisor']
  },

  op_center: {
    key: 'op_center', value: '', label: 'Operation center', select: [],
    roles: ['ib_sales_unit', 'ib_supervisor']
  },

  is_sat: {
    key: 'is_sat', value: '', label: 'SAT is signed', select: [],
    roles: ['ib_sales_unit', 'ib_supervisor']
  },

  status: {key: 'status', value: '', label: 'Status'},

  unit_serial: {
    key: 'unit_serial', value: '', label: 'Unit number',
    roles: ['ib_sales_unit', 'ib_supervisor']
  },

  machine_id: {key: 'no', value: '', label: 'Machine ID'},

  // sales_unit: {key: 'sales_unit', value: '', label: 'Sales unit'},
}

export let projectFilters = writable(_projectFilters)
export let machineFilters = writable(_machineFilters)

export let filtersView = writable([])

export let filteredProjects = writable([])
export let filteredMachines = writable([])

